import { createStore, combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import reduxStorage from 'redux-persist/lib/storage';
// eslint-disable-next-line import/no-unresolved
import { encryptTransform } from 'redux-persist-transform-encrypt';
import {
  loader,
  notify,
  user,
  customer,
  changePassword,
  referral,
  testimonial,
  rooftop
} from './reducers';

// Create the encryptor
const encryptor = encryptTransform({
  secretKey: process.env.REACT_APP_SECURE_LOCAL_STORAGE_HASH_KEY
});

const persistConfig = {
  key: 'root',
  storage: reduxStorage,
  whitelist: ['user', 'rooftop', 'customer', 'referral'],
  transforms: [encryptor]
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    loader,
    notify,
    user,
    rooftop,
    customer,
    referral,
    testimonial,
    changePassword
  })
);

export const store = createStore(persistedReducer);
export const persistor = persistStore(store);
